
const headerData = (title) => {
    const headerVal = []
    headerVal[0] = title
    headerVal[1] = ''
    headerVal[2] = ''
    return headerVal
}

const excelBody = (vm) => {
    const listContractor = []
    vm.report_data.forEach((element, index) => {
        const myObj = {}
        myObj[vm.$t('globalTrans.sl_no')] = vm.$n(index + 1)
        myObj[vm.$t('globalTrans.name')] = vm.$i18n.locale === 'en' ? element.name : element.name_bn
        myObj[vm.$t('child_admission_management.father_name')] = vm.$i18n.locale === 'en' ? element.father_name : element.father_name_bn
        myObj[vm.$t('child_admission_management.mother_name')] = vm.$i18n.locale === 'en' ? element.mother_name : element.mother_name_bn
        myObj[vm.$t('globalTrans.age')] = vm.$n(element.age) + ' ' + vm.$t('globalTrans.year')

        listContractor.push(myObj)
    })
    return listContractor
}

export default {
    headerData,
    excelBody
}
